interface useStackAdaptReturns {
  pushConversion: (trackingCode?: string | null) => void;
}

const useStackAdapt = (): useStackAdaptReturns => {
  const pushConversion = (trackingCode?: string | null): void => {
    const hasAcceptedTracking = window.OnetrustActiveGroups?.indexOf('C4') != -1;

    if (trackingCode != null && trackingCode?.length > 0 && hasAcceptedTracking) {
      window.saq('conv', trackingCode);
    }
  };

  return { pushConversion };
};

export default useStackAdapt;
